import { isNil } from 'lodash';
export const isLoggedIn = () => {
  return !isNil(localStorage.getItem('accessToken'));
};

export const getAccessToken = () => {
  return localStorage.getItem('accessToken');
};
